import { defineComponent as v, ref as _, computed as i, onMounted as y, watch as z, openBlock as a, createElementBlock as l, normalizeClass as m, createElementVNode as k, Fragment as C, renderList as E, toDisplayString as U } from "vue";
import './assets/index4.css';var f = /* @__PURE__ */ ((t) => (t.White = "white", t.Grey = "grey", t))(f || {}), g = /* @__PURE__ */ ((t) => (t.Size24 = "24", t.Size32 = "32", t.Size40 = "40", t.Size48 = "48", t.Size80 = "80", t.Size96 = "96", t.Size128 = "128", t.Size192 = "192", t))(g || {});
function w(t) {
  const e = t.split(" ").filter((s) => s.length > 0);
  if (e.length > 1)
    return e[0][0].toUpperCase() + e[1][0].toUpperCase();
  if (e.length === 1 && e[0].length > 0) {
    if (e[0].length === 1)
      return e[0][0].toUpperCase();
    if (e[0].length > 1)
      return e[0][0].toUpperCase() + e[0][1].toUpperCase();
  }
  return "";
}
const x = ["src", "alt"], N = /* @__PURE__ */ v({
  __name: "Avatar",
  props: {
    fullName: { default: "" },
    src: { default: "" },
    size: { default: "Size96" },
    color: { default: "White" }
  },
  setup(t) {
    const e = t, s = _(!0), c = i(() => s.value === !1 && e.src !== void 0 && e.src.length > 0), p = i(() => {
      const r = ["Avatar"], n = g, u = f;
      return r.push(`Avatar--size-${n[e.size]}`), c.value || (r.push("Avatar--text"), r.push(`Avatar--${u[e.color]}`)), r;
    }), h = i(() => w(e.fullName)), o = async () => {
      if (!e.src) {
        s.value = !0;
        return;
      }
      return new Promise((r) => {
        const n = new Image();
        n.onload = () => {
          s.value = !1, r();
        }, n.onerror = () => {
          s.value = !0, r();
        }, n.src = e.src;
      });
    };
    return y(() => {
      o();
    }), z(
      () => e.src,
      () => {
        o();
      }
    ), (r, n) => c.value ? (a(), l("figure", {
      key: 0,
      class: m(p.value)
    }, [
      k("img", {
        class: "Avatar__img is-inside-mask",
        src: r.src,
        alt: r.fullName,
        onError: o
      }, null, 40, x)
    ], 2)) : (a(), l("div", {
      key: 1,
      class: m(p.value)
    }, [
      (a(!0), l(C, null, E(h.value, (u, d) => (a(), l("span", {
        key: d,
        class: "notranslate"
      }, U(u), 1))), 128))
    ], 2));
  }
});
export {
  N as Avatar,
  f as AvatarColor,
  g as AvatarSize
};
